import { Routes, RouterModule } from '@angular/router';

import { HisAuthGuard } from 'hisng';

import { PatentEditFormComponent } from './component/patent/patent-edit-form.component';
import { PatentViewDetailsComponent } from './component/patent/patent-view-details.component';
import { PatentSearchFormComponent } from './component/patent/patent-search-form.component';
import { PatentSearchResultComponent } from './component/patent/patent-search-result.component';
import { PriorityPatentSearchFormComponent } from './component/patent/prioritypatent-search-form.component';

const PATENT_ROUTES: Routes = [
    {
        path: 'create',
        component: PatentEditFormComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAll: ['RIGHT_FS_RES_PATENT_CREATE_PATENT']
        }
    },
    {
        path: 'create/:priorityPatentId',
        component: PatentEditFormComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAll: ['RIGHT_FS_RES_PATENT_CREATE_PATENT']
        }
    },
    {
        path: 'edit/:patentId',
        component: PatentEditFormComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAny: ['RIGHT_FS_RES_PATENT_EDIT_PATENT']
        }
    },
    {
        path: 'view/:patentId',
        component: PatentViewDetailsComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAny: ['RIGHT_FS_RES_PATENT_EDIT_PATENT', 'RIGHT_FS_RES_PATENT_VIEW_PATENT', 'RIGHT_FS_RES_PATENT_VIEW_PATENT_OWN',
                'RIGHT_FS_RES_PATENT_VIEW_PATENT_VISIBLE'],
            modules: ['HISINONERES']
        }
    },
    {
        path: 'all/search',
        component: PatentSearchFormComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAny: ['RIGHT_FS_RES_PATENT_VIEW_PATENT', 'RIGHT_FS_RES_PATENT_VIEW_PATENT_OWN', 'RIGHT_FS_RES_PATENT_VIEW_PATENT_VISIBLE']
        }
    },
    {
        path: 'priority/search',
        component: PriorityPatentSearchFormComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAny: ['RIGHT_FS_RES_PATENT_VIEW_PATENT', 'RIGHT_FS_RES_PATENT_VIEW_PATENT_OWN', 'RIGHT_FS_RES_PATENT_VIEW_PATENT_VISIBLE']
        }
    },
    {
        path: ':type/searchresult',
        component: PatentSearchResultComponent,
        canActivate: [HisAuthGuard],
        data: {
            hasAny: ['RIGHT_FS_RES_PATENT_VIEW_PATENT', 'RIGHT_FS_RES_PATENT_VIEW_PATENT_OWN', 'RIGHT_FS_RES_PATENT_VIEW_PATENT_VISIBLE']
        }
    },
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PatentRoutesModule = RouterModule.forChild( PATENT_ROUTES );
